import { Component, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-home-introduction-pop-up',
  templateUrl: './home-introduction-pop-up.component.html',
  styleUrls: ['./home-introduction-pop-up.component.scss'],
})
export class HomeIntroductionPopUpComponent {
  constructor(public dialogRef: MatDialogRef<HomeIntroductionPopUpComponent>, private readonly ngZone: NgZone) {}

  onClose(): void {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }
}
